<div class="app-login">
    <div class="body-app mt-3 mb-3">
        <div class="w-100 h-100 d-flex align-items-center justify-content-center">
            <div class="content-app">
                <div class="row">
                    <div class="col-xl-3 col-lg-3 col-md-2 col-sm-12 col-12">
                    </div>
                    <div class="col-xl-6 col-lg-6 col-md-8 col-sm-12 col-12">
                        <div class="card card-login">
                            <div class="card-body">
                                <a routerLink="/" title="RedLaboralRD" class="d-block mt-1 mb-1 mx-auto" style="max-width: 400px;">
                                    <img src="assets/Images/logo.jpg" class="img-fluid" alt="logo" />
                                </a>
                                <h5 class="mt-3 mb-3 text-center text-primary">
                                    {{ isForgotUsername ? 'Recuperar Usuario' : 'Recuperar Contraseña' }}
                                </h5>
            
                                <form [formGroup]="form">
                                    <div class="form-group mb-3">
                                        <label>Email</label>
                                        <div>
                                            <input formControlName="userName" type="userName" class="form-control"
                                                placeholder="Ingrese su correo" required />
                                        </div>
                                    </div>
                                </form>
            
                                <div class="mt-3 mb-3">
                                    <button (click)="submit()" type="button" class="btn btn-primary w-100" [disabled]="isLoading()">
                                        <ng-container *ngIf="!isLoading()">
                                            <i class="fa-solid fa-magnifying-glass"></i>
                                        </ng-container>
                                        <ng-container *ngIf="isLoading()">
                                            <div class="spinner-border spinner-border-sm text-light" role="status">
                                                <span class="visually-hidden">Loading...</span>
                                            </div>
                                        </ng-container>
                                        {{ isForgotUsername ? 'Recuperar Usuario' : 'Recuperar Contraseña' }}
                                    </button>
                                </div>
            
                                <div class="mt-3 mb-3">
                                    <a *ngIf="!isForgotUsername" [routerLink]="['/ForgotUser']" class="text-decoration-none">
                                        <i class="fa-solid fa-circle-user"></i>
                                        ¿Olvido su usuario?
                                    </a>
                                    <a *ngIf="isForgotUsername"  [routerLink]="['/ForgotPassword']" class="text-decoration-none">
                                        <i class="fa-solid fa-key"></i>
                                        ¿Olvido su password?
                                    </a>
                                </div>
                                <div class="text-center">
                                    <a [routerLink]="['/login']" class="text-decoration-none">
                                        <i class="fa-solid fa-circle-user"></i>
                                        Iniciar Sesión
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-xl-3 col-lg-3 col-md-3 col-sm-12 col-12">
                    </div>
                </div>
            </div>
        </div>
    </div>
    <app-footer></app-footer>
</div>